import { RootState } from '@types';

export const selectIsLoadingRates = (state: RootState) => state.deliveryRates.isLoading;
export const selectIsPollingRatesActive = (state: RootState) => state.deliveryRates.isPollingActive;
export const selectIsShippingRatesDepsValid = (state: RootState) => state.deliveryRates.depsAreValid;
export const selectIsShippingRatesReady = (state: RootState) => state.deliveryRates.isReady;
export const selectShippingRatesErrors = (state: RootState) => state.deliveryRates.error;
export const selectShippingRates = (state: RootState) => state.deliveryRates.shippingRates;
